import React, { cloneElement } from "react";
import SidebarItem from "../../components/SidebarItem";
import ResourceDataMap from "../../components/ResourceDataMap";
import { linksCabinet_dossiers } from "routes/navigation/sidebarLinks";
import PropTypes from "prop-types";
import logo from "../../image/logo.png";
import useGetCurrentUser from "hooks/useGetCurrentUser";
import Ellipse from "../../image/Ellipse.png";
import "../sidebar/style.css";
import { useParams } from "react-router-dom";

const SidebarCabinetDossierComponent = ({
  activeLinkColor,
  activeLinkBgColor,
  colorOnHover,
  linkColor,
  openedMenu,
}) => {
  const { clientID: dossier_id } = useParams();
  const ClonedSidebarItem = ({ linkItem }) =>
    cloneElement(
      <SidebarItem
        linkItem={linkItem}
        openedMenu={openedMenu}
        inDossier={true}
        dossier={dossier_id}
      />,
      {
        activeLinkColor,
        activeLinkBgColor,
        colorOnHover,
        linkColor,
      }
    );

  const user = useGetCurrentUser();

  return (
    <div className={`sidebar-shell hideScrollbar ${openedMenu ? "is-collapsed" : ""}`}>
      <div className="sidebar-header-block">
        <div style={{ marginBottom: 20 }}>
          <img src={logo} alt="Easy Compta" style={{ width: "58%", maxWidth: 160 }} />
        </div>
        <div className="sidebar-user-card">
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              overflow: "hidden",
              flexShrink: 0,
            }}
          >
            <img
              src={Ellipse}
              alt="user"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: "#1f2937" }}>
              {user?.first_name} {user?.last_name}
            </div>
            <div style={{ fontSize: 11, color: "#009688", fontWeight: 600 }}>Manager</div>
          </div>
        </div>
        <input type="text" className="sidebar-search" placeholder="Recherche" />
      </div>

      <p className="sidebar-section-title">Aperçu</p>

      <div className="sidebar-nav-scroll">
        <ResourceDataMap
          resourceData={linksCabinet_dossiers}
          resourceItem={ClonedSidebarItem}
          resourceName="linkItem"
        />
      </div>
    </div>
  );
};

SidebarCabinetDossierComponent.propTypes = {
  bgColor: PropTypes.string,
  activeLinkColor: PropTypes.string.isRequired,
  activeLinkBgColor: PropTypes.string.isRequired,
  colorOnHover: PropTypes.string.isRequired,
  linkColor: PropTypes.string.isRequired,
  openedMenu: PropTypes.bool.isRequired,
};

export default SidebarCabinetDossierComponent;
